/**
 * Home Text Animation with SplitText
 * Waits for fonts to load before splitting text to prevent layout issues
 */
(function () {
  'use strict';

  function initTextAnimations() {
    // Ensure GSAP, SplitText, and ScrollTrigger are loaded
    if (typeof gsap === 'undefined' || typeof SplitText === 'undefined' || typeof ScrollTrigger === 'undefined') {
      console.warn('GSAP, SplitText, or ScrollTrigger not loaded');
      return;
    }

    gsap.registerPlugin(SplitText, ScrollTrigger);

    const animateElements = document.querySelectorAll('.animate-text');

    if (animateElements.length === 0) {
      return;
    }

    animateElements.forEach((element) => {
      // Find the paragraph tag inside if it exists, otherwise use the element itself
      const target = element.querySelector('p') || element;

      // Split the text into words
      const split = new SplitText(target, { type: 'words' });

      // Animate the words
      gsap.from(split.words, {
        opacity: 0,
        y: 30,
        duration: 0.6,
        stagger: 0.03,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: element,
          start: 'top 85%',
          toggleActions: 'play none none reverse',
        },
      });
    });
  }

  // Wait for both DOM and fonts to be ready
  function init() {
    if (document.fonts && document.fonts.ready) {
      // Modern browsers: wait for fonts
      document.fonts.ready.then(initTextAnimations);
    } else {
      // Fallback: just run after a small delay
      setTimeout(initTextAnimations, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
